import React from "react";

import "./score_table.scss";
import { observer } from "mobx-react-lite";
import { CupScoreTableType } from "../../../../schemas/cup_score_table";

function CupScoreTable(props: { table: CupScoreTableType }) {
	return (
		<div className="score_table">
			<div className="table_header">{props.table.name}</div>
			{props.table.children.map((group, index) => (
				<div key={index}>
					<div className="group">
						<div className="group_header">
							<div className="group_name">{group.name}</div>
							<div className="group_columns">
								<div className="group_column">И</div>
								<div className="group_column">В</div>
								<div className="group_column">П</div>
								<div className="group_column">Пар</div>
								<div className="group_column">O</div>
							</div>
						</div>
						{group.item.map((item, index) => (
							<div className="group_item" key={index}>
								<div className="item_name_wrapper">
									<div className="item_number">
										{item.num}
									</div>
									<div className="item_logo">
										<img src={item.team.logo} alt=""></img>
									</div>
									<div className="item_name">
										{item.team.name}
									</div>
								</div>
								<div className="item_info">
									<div className="item_info_column">
										{item.I}
									</div>
									<div className="item_info_column">
										{item.B}
									</div>
									<div className="item_info_column">
										{item.P}
									</div>
									<div className="item_info_column">
										{item.SET}
									</div>
									<div className="item_info_column">
										{item.O}
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			))}
		</div>
	);
}

export default observer(CupScoreTable);
